/**
 * EdDialog组件底部按钮属性
 */
export const FooterProps = {
    loading: {type: Boolean},
    /**
     * @description: Show close button
     */
    showCancelBtn: {type: Boolean, default: true},
    cancelButtonProps: {
        type: Object, default: () => {
            return {size: 'small'}
        }
    },
    cancelText: {type: String, default: '关 闭'},
    /**
     * @description: Show confirmation button
     */
    showOkBtn: {type: Boolean, default: true},
    okButtonProps: {
        type: Object,
        default: () => {
            return {
                size: 'small',
                type: "primary"
            }
        }
    },
    okText: {type: String, default: '确 定'},
    showFooter: {type: Boolean, default: true},
    footerHeight: {type: [String, Number], default: 60,},
}

/**
 * EdDialog组件属性
 */
export default {
    // 是否显示 Dialog，支持 .sync 修饰符
    visible: {type: Boolean, default: false},

    // Dialog 的标题，也可通过具名 slot （见下表）传入
    title: {type: String, default: ""},

    // Dialog 的宽度 Number类型为px单位
    width: {type: [String, Number], default: '50%'},

    // Dialog 的高度 Number类型为px单位，请勿用百分比高度（如50%），因为父元素没有初始高度
    height: {type: [String, Number]},

    // 是否为全屏 Dialog
    fullscreen: {type: Boolean, default: false},

    // Dialog CSS 中的 margin-top 值
    top: {type: String, default: "12vh"},

    // 是否需要遮罩层
    modal: {type: Boolean, default: true},

    // 遮罩层是否插入至 body 元素上，若为 false，则遮罩层会插入至 Dialog 的父元素上
    modalAppendToBody: {type: Boolean, default: true},

    // Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true
    appendToBody: {type: Boolean, default: true},

    // 是否在 Dialog 出现时将 body 滚动锁定
    lockScroll: {type: Boolean, default: true},

    // Dialog 的自定义类名
    customClass: {type: String, default: "ed-dialog"},

    // 是否可以通过点击 modal 关闭 Dialog
    closeOnClickModal: {type: Boolean, default: true},

    // 是否可以通过按下 ESC 关闭 Dialog
    closeOnPressEscape: {type: Boolean, default: true},

    // 是否显示关闭按钮
    showClose: {type: Boolean, default: true},

    // 关闭前的回调，会暂停 Dialog 的关闭
    beforeClose: {type: Function},

    // 是否对头部和底部采用居中布局
    center: {type: Boolean, default: false},

    // 关闭时销毁 Dialog 中的元素
    destroyOnClose: {type: Boolean, default: true},


    ...FooterProps
}
